import {
  LOAN_APPLICATION_FETCH_SUCCESS,
  BUILD_COMMITMENT,
  COMMITMENT_CHANGED,
  UPDATE_EXPENSE_SUCCESS,
  UPDATE_COMMITMENTS_FAILURE,
  LOAN_APPLICATION_USER_GOBACK_SUCCESS,
  LOAN_APPLICATION_USER_GOTO_SUCCESS,
} from './../../actions/types'

const byId = (state = {}, {type, payload}) => {
  switch (type) {
    case LOAN_APPLICATION_FETCH_SUCCESS:
      return payload.applicationFlow.commitments || state
    case COMMITMENT_CHANGED:
      const { key } = payload
      const updatedCommitment = {...state[key], ...payload }
      updatedCommitment.errors = {};
      return { ...state, [key]: updatedCommitment }
    case BUILD_COMMITMENT:
      return {
        ...state,
        [payload.key]: { ...payload.data, errors: {} }
      }
    case UPDATE_COMMITMENTS_FAILURE:
      return payload.entities || {}

    case UPDATE_EXPENSE_SUCCESS:
    case LOAN_APPLICATION_USER_GOTO_SUCCESS:
    case LOAN_APPLICATION_USER_GOBACK_SUCCESS:
      if (payload.commitments !== undefined) {
        return payload.commitments || {}
      } else {
        return state
      }
    default:
      return state;
  }
}

export default byId;
